import React, { useEffect } from 'react';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import './styles.scss';
import useFeedbackModal from './useFeedbackModalHook';

export default function FeedbackModal({ open, onClose }) {
  const {
    loading,
    submitted,
    erro,
    handleSubmit,
    setDescricao,
    setAceitaEntrarEmContato,
    setSubmitted,
    descricao,
    aceitaEntrarEmContato,
    setErro
  } = useFeedbackModal();
  useEffect(() => {
    if (!open) {
      setDescricao('');
      setAceitaEntrarEmContato(false);
      setSubmitted(false);
      setErro(false);
    }
  }, [open]);

  return (
    <>
      <Modal open={open} onClose={onClose} className="feedback-modal" disableAutoFocus>
        <Box>
          <Box className="feedback-modal-container">
            <div className="feedback-modal-header">
              <Typography component="h2" className="feedback-modal-title">
                {submitted ? 'Feedback enviado!' : 'Enviar feedback'}
              </Typography>
              <IconButton aria-label="fechar" className="feedback-modal-close-btn" onClick={onClose}>
                <CloseIcon />
              </IconButton>
            </div>

            {submitted ? (
              <Box className="feedback-modal-success">
                <Typography className="feedback-modal-description">
                  Seu feedback foi registrado! Agradecemos por nos ajudar a melhorar a Plataforma.
                </Typography>
              </Box>
            ) : (
              <>
                <Typography className="feedback-modal-description">
                  Conte pra gente como está sendo sua experiência com a Plataforma. Seu feedback nos
                  ajuda a melhorar cada vez mais!
                </Typography>
                <textarea
                  className="feedback-modal-textarea"
                  placeholder="Digitar feedback"
                  value={descricao}
                  maxLength={500}
                  onChange={e => setDescricao(e.target.value)}
                />
                <FormControlLabel
                  className="feedback-modal-checkbox"
                  control={
                    <Checkbox
                      checked={aceitaEntrarEmContato}
                      onChange={e => setAceitaEntrarEmContato(e.target.checked)}
                    />
                  }
                  label="A One7 pode entrar em contato comigo sobre esse feedback."
                />
                <div className="feedback-modal-actions">
                  <Button
                    variant="contained"
                    disabled={loading || descricao === ''}
                    onClick={handleSubmit}
                    className="feedback-modal-submit-btn"
                  >
                    {loading ? 'Enviando...' : 'Enviar feedback'}
                  </Button>
                </div>
              </>
            )}
          </Box>
          <Snackbar
            open={erro}
            autoHideDuration={5000}
            onClose={() => setErro(false)}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          >
            <Alert severity="error" className="erro-alerta">
              Ocorreu um erro ao enviar o feedback.
            </Alert>
          </Snackbar>
        </Box>
      </Modal>
    </>
  );
}
